import $ from 'jquery';

const vidControl = () => {
    const video = document.getElementById('video1');
    if (video) {
        video.addEventListener('click', function(e) {
            // handle click if not Firefox (Firefox supports this feature natively)
            if (typeof InstallTrigger === 'undefined') {
                // get click position
                const clickY = e.pageY - $(this).offset().top;
                const height = parseFloat($(this).height());

                // avoids interference with controls
                if (clickY > 0.82 * height) return;

                // toggles play / pause
                // eslint-disable-next-line no-unused-expressions
                video.paused ? this.play() : this.pause();
            }
        });
    }
};

export default vidControl;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/stetson-europe-chisel/src/scripts/modules/video.js